import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { SkuCard } from '@cimpress-technology/ff-react-components/lib/SkuSelector';
import { SkuInfoShape } from '../shared/SkuCard/SkuCard';
import { withTranslation } from 'react-i18next';

class ListPriceSkuCard extends PureComponent {
  static propTypes = {
    skuInfo: SkuInfoShape.isRequired,
    onAddAction: PropTypes.func.isRequired,
    shouldExcludeSku: PropTypes.func.isRequired
  };

  render() {
    const { skuInfo, onAddAction, shouldExcludeSku, t } = this.props;

    return (
      <SkuCard
        skuInfo={skuInfo}
        disabled={!skuInfo.isListPrice}
        disabledTooltipMsg={t('createContract:addProducts.disabledListPriceMessage')}
        actionIcon={shouldExcludeSku(skuInfo.sku) ? 'check-circle-2-f' : 'add-circle-1'}
        onAction={onAddAction}
        hasAction
      />
    );
  }
}

export default withTranslation()(ListPriceSkuCard);
